import type { IconSvgObject } from './types';

const TickDouble01Icon: IconSvgObject = [
  ["path", { d: "M2.5 13.8333C2.5 13.8333 4.5 15 6 17.5C6 17.5 6.28485 17.0192 6.82133 16.2526M16.5 6.5C14.2085 7.64577 11.8119 10.0518 9.88791 12.3223", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.5 13.8333C7.5 13.8333 9.5 15 11 17.5C11 17.5 16.5 9 21.5 6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TickDouble01Icon;
